export const state = {
  gameIsOver: false,
  nytBookDate: "",
  nytCategoryNames: [],
  booksFetchedFromNYT: [],
  booksSelectedAtRandom: [],
  booksCategorizedByOpenAI: [],
  finalizedBooks: [],
  finalizedCategories: [],
  userSelections: [[], [], []],
  booksToSelectFrom: [],
  answers: [],
  pickedDate: "",
  score: 0,
  secondRoundHand: [],
};
